import { API_BASE_URL } from '../services/api';

/** Normalize API / Date values to YYYY-MM-DD */
export function toYmd(val) {
  if (!val) return '';
  if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}/.test(val)) {
    return val.slice(0, 10);
  }
  const d = new Date(val);
  if (Number.isNaN(d.getTime())) return '';
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function isSameCalendarDay(a, b) {
  const ymdA = toYmd(a);
  const ymdB = toYmd(b);
  return Boolean(ymdA && ymdB && ymdA === ymdB);
}

/** Value date used for recent-deals blotter filtering (with sensible fallbacks). */
export function getDealFilterDateYmd(deal) {
  if (!deal) return '';
  const raw =
    deal.value_date ??
    deal.valueDate ??
    deal.leg1_value_date ??
    deal.leg1_trade_date ??
    deal.trade_date ??
    deal.tradeDate ??
    deal.rawValueDate;
  return toYmd(raw);
}

export function filterDealsByFilterDate(deals, filterYmd) {
  if (!filterYmd || !Array.isArray(deals)) return deals || [];
  return deals.filter((deal) => getDealFilterDateYmd(deal) === filterYmd);
}

export async function fetchSystemDayYmd() {
  try {
    const res = await fetch(`${API_BASE_URL}/system-day`);
    if (!res.ok) throw new Error('system-day failed');
    const json = await res.json();
    const day = json.system_day ? String(json.system_day).split('T')[0] : '';
    if (day) return day;
  } catch (_) {
    /* fall through */
  }
  return toYmd(new Date());
}
